export default "__VITE_ASSET__OpM_bU7r__"